import styled from 'styled-components';

import { colors, mediaRetina } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const SecondaryButton = styled(ButtonWithStyles)`
  ${({ blue, green, reverse, light, width }) => {
    let primaryColor = colors.battleshipGrey;
    if (blue) {
      primaryColor = colors.waterBlue;
    } else if (green) {
      primaryColor = colors.turtleGreen;
    } else if (light) {
      primaryColor = colors.aluminum;
    }

    const buttonTheme = {
      // TODO: Fix this the next time the file is edited.

      textColor: reverse ? 'white' : primaryColor,
      // TODO: Fix this the next time the file is edited.

      borderColor: reverse ? 'white' : primaryColor,
      hoverTextColor: reverse ? colors.waterBlue : colors.turtleGreen,
      hoverBorderColor: reverse ? 'white' : colors.turtleGreen,
      hoverBgColor: reverse ? 'white' : 'transparent',
    };
    return `
      color: ${buttonTheme.textColor};
      width: ${width};
      box-shadow: inset 0 0 0 1px ${buttonTheme.borderColor};
      &:not([disabled]):hover {
        color: ${buttonTheme.hoverTextColor};
        background-color: ${buttonTheme.hoverBgColor};
        box-shadow: inset 0 0 0 1px ${buttonTheme.hoverBorderColor};
        text-decoration: none;
        &:disabled {
          &:hover {
            background-color: transparent;
            box-shadow: inset 0 0 0 1px ${buttonTheme.borderColor};
          }
        }
      }
      ${mediaRetina} {
        box-shadow: inset 0 0 0 1.5px ${buttonTheme.borderColor};
        &:not([disabled]):hover {
          box-shadow: inset 0 0 0 1.5px ${buttonTheme.hoverBorderColor};
        }
      }
    `;
  }}
`;
